module.exports = __webpack_public_path__ + "img/over_sale.b756f0b1.png";